import Vue from 'vue'
import moment from 'moment'
import { format, parse } from 'date-fns'
import store from '../store'

Vue.mixin({
  data: () => ({

  }),
  mounted() {
    // this.recaptcha();
  },
  created() {
    // this.recaptcha();
    try {
      const recaptcha = this.$recaptchaInstance

      // Hide reCAPTCHA badge:
      recaptcha.hideBadge()
    } catch (e) {
    }

    // Show reCAPTCHA badge:
    // recaptcha.showBadge()
  },
  methods: {

    openLink(url, target) {
      Object.assign(document.createElement('a'), {
        target,
        href: url,
      }).click()
    },
    copy(text) {
      navigator.clipboard.writeText(text)
        .then(() => {
          // this.toast("Link Copied", "dark");
          this.$store.commit('setValue', {
            type: 'display_notification',
            value: { message: 'Copied to clipboard', color: 'dark' },
          })

          // console.log('Text copied to clipboard');
        })
        .catch(err => {
          this.$store.commit('setValue', {
            type: 'display_notification',
            value: { message: 'Copy failed', color: 'red' },
          })

          // This can happen if the user denies clipboard permissions:
          // this.toast("Copy failed", "danger");
          // console.error('Could not copy text: ', err);
        })
    },
    openInNewTab(url) {
      Object.assign(document.createElement('a'), {
        target: '_blank',
        href: url,
      }).click()
    },
    isElementInViewport(el) {
      const rect = el.getBoundingClientRect()

      return (
        rect.top >= 0
                && rect.left >= 0
                && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) /* or $(window).height() */
                && rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
      )
    },
    inMobile() {
      window.mobileAndTabletcheck = function () {
        let check = false;
        (function (a) {
          if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true
        }(navigator.userAgent || navigator.vendor || window.opera))

        return check
      }

      return window.mobileAndTabletcheck()
    },
    validURL(str) {
      const pattern = new RegExp('^(https?:\\/\\/)?' // protocol
                + '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' // domain name
                + '((\\d{1,3}\\.){3}\\d{1,3}))' // OR ip (v4) address
                + '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' // port and path
                + '(\\?[;&a-z\\d%_.~+=-]*)?' // query string
                + '(\\#[-a-z\\d_]*)?$', 'i') // fragment locator

      return !!pattern.test(str)
    },
    kFormatter(num) {
      const si = [
        { value: 1, symbol: '' },
        { value: 1E3, symbol: 'k' },
        { value: 1E6, symbol: 'M' },
        { value: 1E9, symbol: 'G' },
        { value: 1E12, symbol: 'T' },
        { value: 1E15, symbol: 'P' },
        { value: 1E18, symbol: 'E' },
      ]
      const rx = /\.0+$|(\.[0-9]*[1-9])0+$/
      let i
      for (i = si.length - 1; i > 0; i--) {
        if (num >= si[i].value) {
          break
        }
      }

      return (num / si[i].value).toFixed(1).replace(rx, '$1') + si[i].symbol
    },

    /*
       method to get index of an item in an array
       using a field and a value of comparison
        */
    getIndex(items, field, value) {
      for (let i = 0; i < items.length; i++) {
        if (items[i][field] == value) {
          return i
        }
      }

      return -1
    },

    /*
           method to get an item in an array
           using a field and a value of comparison
            */
    getItem(items, field, value) {
      for (let i = 0; i < items.length; i++) {
        if (items[i][field] === value) {
          return items[i]
        }
      }

      return false
    },
    shortHtml(string, len) {
      if (!string || string.length < len) {
        return string || ''
      }
      const length = len || 170
      let openTag = 0; let closeTag = 0; let i = 0

      for (i; i < length; i++) {
        if (string[i] === '<') openTag++
        if (string[i] === '>') closeTag++
      }
      if (openTag > closeTag) {
        while (string[i] !== '>') i++
      }

      const newString = string.substring(0, (i + 1))

      return newString + (string.length > newString.length ? '...' : '')
    },
    getItemValue(model, str, d = null) {
      if (model == null || !str) {
        return d
      }
      try {
        if (str.indexOf('.') < 0) {
          if(model[str] === 0)
            return 0
          return model[str] || d
        }
        const current = str.slice(0, (str.indexOf('.')))
        const next = str.slice((str.indexOf('.')) + 1)
        model = model[current]

        return (model) ? this.getItemValue(model, next, d) : null
      } catch (e) {
        return d
      }
    },
    stateColor(value, action, autoHeight = false) {
      if (!value) return {}

      if (value.length > 0 && value.filter(ele => action === ele.colomn_name).length > 0) {
        let records = []
        records = value.filter(ele => action === ele.colomn_name)

        /* item.value.color_id = records[0].color_id || null
        item.value.fore_color_id = records[0].fore_color_id || null */

        if (!records.length || !records[0].color_id) return {}

        return {
          'background-color': records[0].color.bg_color, color: records[0].fore_color_id ? records[0].forecolor.bg_color : '#000000'/* records[0].color.txt_color */, height: autoHeight ? 'auto' : '100%', display: 'flex', 'align-items': 'center', 'justify-content': 'center',
        }
      }

      let records = []
      if (action === 'send_date') {
        records = value.filter(ele => ele.type && ele.type === 'send_date').sort((a, b) => b.id - a.id)
      } else {
        records = value.filter(ele => ele.type && ele.type.includes(action)).sort((a, b) => b.id - a.id)
      }
      if (!records || records.length === 0 || !records[0].color || !records[0].color.id) return {}

      return {
        'background-color': records[0].color.bg_color + ' !important', color: records[0].color.txt_color, height: autoHeight ? 'auto' : '100%', display: 'flex', 'align-items': 'center', 'justify-content': 'center',
      }
    },
    isColor(value, action, colorId) {
      if (!value) return {}

      if (value.length > 0 && value.filter(ele => action === ele.colomn_name).length > 0) {
        let records = []
        records = value.filter(ele => action === ele.colomn_name)

        /* item.value.color_id = records[0].color_id || null
        item.value.fore_color_id = records[0].fore_color_id || null */

        if (!records.length || !records[0].color_id) return {}

        return records[0] && records[0].color_id && records[0].color_id === colorId
      }
    },
    isCompleted(val) {
      if (val && val.state >= store.state.app.states.RESILIATION_STATE) {
        return true
      }

      return false
    },
  },
})
